import React from 'react';
import { Link } from 'react-router-dom';
import { HelpCircle, ArrowRight } from 'lucide-react';
import PageBanner from '../components/PageBanner';
import Reveal from '../components/Reveal';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../components/ui/accordion';
import { FAQS } from '../mock';

export default function Faq() {
  return (
    <div>
      <PageBanner
        title="Frequently Asked Questions"
        subtitle="Got a question? Want to know more? Start here."
        crumb="FAQ"
        image="https://images.unsplash.com/photo-1460925895917-afdab827c52f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwxfHxidXNpbmVzcyUyMGFuYWx5dGljc3xlbnwwfHx8fDE3OTA4NDkyNjR8MA&ixlib=rb-4.1.0&q=85"
      />

      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-5 lg:px-8">
          <Reveal className="text-center mb-12">
            <div className="w-16 h-16 rounded-full bg-[#eaf6fc] text-[#1ca5dc] flex items-center justify-center mx-auto mb-5">
              <HelpCircle size={30} />
            </div>
            <h2 className="font-heading font-extrabold text-2xl md:text-3xl text-[#132b4d]">
              Your questions answered
            </h2>
            <p className="mt-4 text-gray-600">
              If the answer isn’t here, <Link to="/contact" className="text-[#1ca5dc] font-semibold hover:underline">contact us</Link>.
            </p>
          </Reveal>

          <Reveal>
            <Accordion type="single" collapsible className="space-y-4">
              {FAQS.map((f, i) => (
                <AccordionItem
                  key={f.q}
                  value={`item-${i}`}
                  className="border border-gray-200 rounded-xl px-6 data-[state=open]:border-[#1ca5dc] data-[state=open]:shadow-md transition-all"
                >
                  <AccordionTrigger className="text-left font-heading font-semibold text-[#132b4d] hover:text-[#1ca5dc] hover:no-underline py-5">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-gray-600 leading-relaxed pb-5">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        </div>
      </section>

      <section className="pb-20 bg-white">
        <div className="max-w-4xl mx-auto px-5 lg:px-8">
          <div className="bg-[#f6f9fc] rounded-2xl p-10 text-center border border-gray-100">
            <h3 className="font-heading font-extrabold text-2xl text-[#132b4d] mb-3">Couldn’t solve your problem?</h3>
            <p className="text-gray-600 mb-7">If we didn’t answer your question, let’s get a human involved.</p>
            <Link to="/contact" className="inline-flex items-center gap-2 bg-[#1ca5dc] text-white font-heading font-semibold px-8 py-3.5 rounded-full hover:bg-[#132b4d] transition-colors">
              Contact us <ArrowRight size={18} />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
